export default {
      id: "arrow-circle-plain-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "svg/sprite.svg#arrow-circle-plain",
      toString: function () {
        return this.url;
      }
    }